import styled from 'styled-components'

export const ZakupLicencjiPlatnoscStyle = styled.div`
  text-align: center;
  display: grid;
  grid-row-gap: 24px;

  .paymentText {
    text-align: justify;
    width: 826px;
    margin: auto;
  }

  .paymentBtn {
    width: 72px;
    margin: auto;
  }
  .paymentSummary {
    display: grid;
    grid-template-columns: 121px auto;
    grid-template-rows: auto auto auto;
    grid-column-gap: 16px;
    grid-row-gap: 4px;
    justify-content: center;

    .text-end {
      padding-top: 4px;
      text-align: end;
    }

    .text-start {
      text-align: start;
    }
  }
`

export const ZakupLicencjiDaneDoFakturyStyle = styled.div`
  fieldset {
    height: 72px;
  }

  .medium-headline-5 {
    text-align: center;
  }

  .expansionPanel {
    .ExpansionPanelSummary {
      padding: 0px;
      > div {
        margin: 8px 0;
      }
    }
  }

  .details {
    margin: 0 !important;
    padding: 8px 20px 0 20px !important;
  }

  .identyfikacjaPodmiotu {
    width: 100%;
    display: grid;

    .firstRow {
      display: flex;
      align-items: flex-end;

      button {
        margin-left: 16px;
        margin-bottom: 24px;
      }
    }
  }

  .adres {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
  }
  .adres .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }
  .adres .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 424px 104px auto;
    grid-column-gap: 16px;
  }
  .adres .thirdRow {
    grid-row: 3/4;
    display: grid;
    grid-template-columns: 424px auto;
    grid-column-gap: 16px;
  }

  .errorCheckboxLabel {
    span {
      color: #f44336;
    }
  }
`

export const ZakupLicencjiWariantStyle = styled.div`
  .header {
    text-align: center;
    margin-bottom: 16px;
  }

  .wariantList {
    display: grid;
    grid-template-columns: 328px 328px 328px;
    grid-column-gap: 20px;
  }

  .wariantMain {
    height: 554px;
    background: white;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
    padding-bottom: 8px;
  }

  .wariant {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wariantIdent {
    width: 100%;
    padding: 16px 16px 12px 16px;
    display: grid;
    grid-template-columns: 100px 1fr;
  }

  .wariantDesc {
    padding: 8px 12px;
  }

  .avatarContainer {
    width: 80px;
    height: 80px;
  }

  .avatarBackground {
    width: 80px;
    height: 80px;
    opacity: 0.16;
  }

  .avatarIcon {
    width: 48px;
    height: 48px;
  }

  .avatarColorFirma {
    color: ${props => props.theme.avatar_Firma};
  }

  .avatarColorBiuro {
    color: ${props => props.theme.avatar_Biuro};
  }

  .avatarColorPremium {
    color: ${props => props.theme.avatar_Premium};
  }

  .structureList {
    width: 100%;
    padding-left: 20px;
  }

  .structureRow {
    display: flex;
    padding: 4px 0 4px 0;
  }

  .structureSymbol {
    border-radius: 50%;
    display: grid;
    justify-content: center;
    align-content: center;
    width: 36px;
    height: 36px;
    color: white;
    font-size: 20px;
  }

  .structureLabel {
    padding-left: 8px;
  }

  .price {
    padding-top: 8px;
  }

  .priceReplacementIcon {
    width: 36px;
    height: 36px;
    color: ${props => props.theme.black38};
  }

  .IN {
    background: ${props => props.theme.ticket_IN_dark};
  }
  .MA {
    background: ${props => props.theme.ticket_MA_dark};
  }
  .MI {
    background: ${props => props.theme.ticket_MI_dark};
  }
  .OP {
    background: ${props => props.theme.ticket_OP_dark};
  }
  .DM {
    background: ${props => props.theme.ticket_DM_dark};
  }
  .SIN {
    background: ${props => props.theme.ticket_SIN_dark};
  }
  .ZU {
    background: ${props => props.theme.ticket_ZU_dark};
  }
`

const ZakupLicencjiStyle = styled.div`
  margin: auto;

  section {
    width: 1048px;
    height: 756px;
    background-color: ${props => props.theme.black4};
    display: grid;
    grid-template-rows: auto auto 1fr;
  }

  header {
    display: flex;
    justify-content: space-between;
    padding: 11px 12px 0 12px;
  }

  main {
    padding: 0px 12px 16px 12px;
  }

  footer {
    width: 100%;
    padding: 0 12px 12px 12px;
    display: flex;
    justify-content: space-between;
  }

  .contact {
    text-align: center;
  }

  .steper {
    > div {
      background-color: ${props => props.theme.black4};
      padding: 12px 24px;
    }
  }

  .imgContainerSmall {
    color: #aea79f;
    border-radius: 50%;
    display: grid;
    justify-content: center;
    align-content: center;
    width: 48px;
    height: 48px;
    background: white;
    cursor: pointer;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  }
`

export default ZakupLicencjiStyle
